:host {
  display: block;
  margin-top: var(--spacer-4);
}

aha-imported-json-viewer {
  --background-color: var(--theme-primary-background);
  --color: var(--theme-primary-text);
  --string-color: var(--aha-green-800);
  --number-color: var(--aha-orange-700);
  --boolean-color: var(--aha-blue-700);
  --null-color: var(--aha-purple-700);
  --property-color: var(--aha-teal-700);
  --preview-color: rgba(var(--rgb-gray-700), 0.9);
  --highlight-color: var(--aha-blue-200);
  --indentguide-color: var(--aha-gray-400);
  --indentguide-color-active: var(--aha-gray-600);
}

.actions-toolbar {
  display: flex;
  flex-direction: column;
  gap: var(--spacer-4);
  margin-bottom: var(--spacer-5);
}

.main-actions,
.search-filter-actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacer-2);
  align-items: center;
}

.actions-toolbar button {
  display: flex;
  align-items: center;
  gap: var(--spacer-1);
  padding: var(--spacer-1) var(--spacer-2);
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: var(--spacer-1);
  cursor: pointer;
  transition: background-color 0.3s;
}

.actions-toolbar button:hover {
  background-color: #e0e0e0;
}

.search-container {
  display: flex;
  align-items: center;
  gap: var(--spacer-1);
}

.search-container input {
  padding: var(--spacer-1);
  border: 1px solid #ccc;
  border-radius: var(--spacer-1);
}

.search-container label{
  display: flex;
  align-items: center;
  gap: var(--spacer-1);
  font-weight: bold;
}

.fa-circle-question {
  cursor: help;
  color: #888;
}

aha-tooltip {
  --aha-tooltip-max-width: 300px;
}

aha-tooltip ul {
  padding-left: var(--spacer-5);
  margin: var(--spacer-1) 0;
}

aha-tooltip code {
  background-color: #f0f0f0;
  padding: var(--spacer-05) var(--spacer-1);
  border-radius: var(--spacer-1);
}
